export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};

export const trackOfferAction = (action, data) => {
  if (action === "accept") track("accept_offer");
  if (action === "complete" && data?.status === "completed") track("complete_trade");
};

let lastPath = null;
export const trackPageView = (path) => {
  if (path === lastPath) return;
  lastPath = path;
  track("page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
};
